import { Injectable } from '@angular/core';
import { CoreRepository } from '@tcc-mono/shared/data-access';
import { Vehicle } from '@tcc-mono/vandijk/shared/data-access/models';
import { VehicleService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VehicleRepository extends CoreRepository<Vehicle> {

  public vehicles$: Observable<Vehicle[]> = this.entities$;
  public selectedVehicle$: Observable<Vehicle> = this.activeEntity$;

  public constructor(
    protected readonly _vehicleService: VehicleService
  ) {
    super(
      { name: 'vehicles' },
      _vehicleService
    )
  }

  public addVehicle = (vehicle: Partial<Vehicle>): Observable<Vehicle> => {
    return this.addEntity(vehicle);
  }

  public updateVehicle = (vehicleId: number, vehicle: Vehicle): Observable<Vehicle> => {
    return this.updateEntity(vehicleId, vehicle);
  }

  public getVehicle = (vehicleId: number): Observable<Vehicle> => {
    return this.getEntity(vehicleId);
  }

  public removeVehicle = (vehicleId: number): Observable<unknown> => {
    return this.removeEntity(vehicleId);
  }

  public setActiveVehicle = (vehicleId: number): void => {
    this.setActiveEntity(vehicleId);
  }
}
